"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleSet = void 0;
class RuleSet {
    constructor() {
        this.constraints = [];
        this.fields = {};
        this.type = () => 'RULESET';
    }
    shouldEvaluate(data) {
        return this.constraints.reduce((res, current) => {
            res = res && current.isRespected(data);
            return res;
        }, true);
    }
    evaluateField(field, rules, data) {
        for (let i = 0; i < rules.length; i++) {
            const res = rules[i].evaluate(field, data);
            if (!res.valid) {
                return res;
            }
        }
        return { valid: true };
    }
    evaluate(path, data, multi = false) {
        const ret = { valid: true };
        const fieldList = Object.keys(this.fields);
        for (let i = 0; i < fieldList.length; i++) {
            const res = this.evaluateField(fieldList[i], this.fields[fieldList[i]], data);
            if (!res.valid) {
                if (multi) {
                    ret.valid = false;
                    ret.details = ret.details || [];
                    ret.details.push(res);
                }
                else {
                    return res;
                }
            }
        }
        return ret;
    }
    addConstraint(constraint) {
        this.constraints.push(constraint);
        return this;
    }
    addRule(field, rules) {
        this.fields[field] = rules;
        return this;
    }
}
exports.RuleSet = RuleSet;
//# sourceMappingURL=RuleSet.js.map